"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _device = require("../styles/device");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * @props column(boolean), responsive, flex, flexWrap, justifyContent, alignItems, width, height, padding, margin, cursor, backgroundColor
 * @notes default media query: 768px - To change the device you need to extend the element
 */
var FlexContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: ", ";\n    justify-content: ", ";\n    align-items: ", ";\n    width: ", ";\n    height: ", ";\n    flex-wrap: ", ";\n    padding: ", ";\n    margin: ", ";\n    flex: ", ";\n    gap: ", ";\n    background-color: ", ";\n    min-width: ", ";\n    min-width: ", ";\n    max-width: ", ";\n    min-height: ", ";\n    max-height: ", ";\n    text-align:", ";\n    overflow: ", ";\n    @media ", "{\n        flex-direction: ", ";\n    }\n"])), function (props) {
  return props.responsive && props.column ? 'row' : props.responsive ? 'column' : props.column && 'column';
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.flexWrap;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.flex;
}, function (props) {
  return props.gap;
}, function (props) {
  return props.theme.colors[props.backgroundColor];
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.minHeight;
}, function (props) {
  return props.maxHeight;
}, function (props) {
  return props.textAlign;
}, function (props) {
  return props.overflow;
}, _device.device.midSize, function (props) {
  return props.column ? 'column' : 'row';
});

var _default = FlexContainer;
exports.default = _default;